import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../scss/color.scss';

interface ColorProperties {
  qrValues: any;
  setQrValues: React.Dispatch<React.SetStateAction<any>>;
}

/**
 * QR Color Component
 * @param {ColorProperties} properties - Component properties
 * @param {any} properties.qrValues - The qrValues prop
 * @param {React.Dispatch<React.SetStateAction<any>>} properties.setQrValues - The setQrValues prop
 * @returns {JSX.Element} The Color component layout
 */
function Color({ qrValues, setQrValues }: ColorProperties): JSX.Element {
  const { t } = useTranslation('qrCode');
  const colors = [
    {
      id: 1,
      label: t('qrCode'),
    },
    {
      id: 2,
      label: t('qrBackgroundColor'),
    },
    {
      id: 3,
      label: t('innerEyeColor'),
    },
    {
      id: 4,
      label: t('outerEyeColor'),
    },
  ];

  /**
   * Handling QR Code Colors
   * @param {React.ChangeEvent<HTMLInputElement>} event - Input change event
   */
  const handleColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setQrValues((previous: any) => ({
      ...previous,
      [name]: value,
    }));
  };

  return (
    <div className="color-wrapper">
      <div className="color">
        {colors.map((color) => (
          <div key={color.id} className="color-section">
            <div>{color.label}</div>
          </div>
        ))}
      </div>
      <div className="color-inputs">
        <input
          type="color"
          onChange={handleColorChange}
          name="fgColor"
          value={qrValues.fgColor}
        />
        <input
          type="color"
          onChange={handleColorChange}
          name="bgColor"
          value={qrValues.bgColor}
        />
        <input
          type="color"
          onChange={handleColorChange}
          name="innerColor"
          value={qrValues.innerColor}
        />
        <input
          type="color"
          onChange={handleColorChange}
          name="outerColor"
          value={qrValues.outerColor}
        />
      </div>
    </div>
  );
}

export default Color;
